import { Injectable } from '@angular/core';
import { AjustesProvider } from '../ajustes/ajustes';
import { TipoSonidoEvento } from '../../models/ajustes-data.model';
import { TextToSpeechAdvanced, TTSOptions, TTSVoice } from '@awesome-cordova-plugins/text-to-speech-advanced/ngx';
import { Platform } from '@ionic/angular';
import { NativeAudio } from '@awesome-cordova-plugins/native-audio/ngx';
/*
  Generated class for the SonidosalertaProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
  providedIn: 'root'
})
export class SonidosalertaProvider {
  private strIdentifier = 'com.apple.ttsbundle.Samantha-compact';
  private arrVoices: TTSVoice[] = [];

  constructor(
    public nativeAudio: NativeAudio,
    private platform: Platform,
    private tts: TextToSpeechAdvanced,
    private ajustesProvider: AjustesProvider) {
    // console.log('Hello SonidosalertaProvider Provider');

    if (this.platform.is('cordova')) {

      this.tts.getVoices().then(voices => {
        //console.log(voices);
        this.arrVoices = voices;
        this.strIdentifier = this.arrVoices[0].identifier;
      });

    }
  }

  initSounds() {
    const strRutaSonidos = `assets/sounds/${this.ajustesProvider.ajustes.strTemaSonidos}`;

    if (this.platform.is('cordova')) {
      this.nativeAudio.preloadSimple(TipoSonidoEvento.MensajeError,
        `${strRutaSonidos}/${this.ajustesProvider.ajustes.strMensajeError}`).catch(error => console.log(error));
      this.nativeAudio.preloadSimple(TipoSonidoEvento.MensajeCorrecto,
        `${strRutaSonidos}/${this.ajustesProvider.ajustes.strMensajeCorrecto}`).catch(error => console.log(error));
      this.nativeAudio.preloadSimple(TipoSonidoEvento.MensajeErrorConeccion,
        `${strRutaSonidos}/${this.ajustesProvider.ajustes.strMensajeErrorConeccion}`).catch(error => console.log(error));
      this.nativeAudio.preloadSimple(TipoSonidoEvento.MensajeCorrectoConeccion,
        `${strRutaSonidos}/${this.ajustesProvider.ajustes.strMensajeCorrectoConeccion}`).catch(error => console.log(error));
      this.nativeAudio.preloadSimple(TipoSonidoEvento.MensajeCompletado,
        `${strRutaSonidos}/${this.ajustesProvider.ajustes.strMensajeCompletado}`).catch(error => console.log(error));
      this.nativeAudio.preloadSimple(TipoSonidoEvento.MensajeAtencion,
        `${strRutaSonidos}/${this.ajustesProvider.ajustes.strMensajeAtencion}`).catch(error => console.log(error));
    }
  }

  playsound(Mensaje: TipoSonidoEvento) {
    // console.log('playsound');
    if (!this.platform.is('cordova')) {
      // console.log('core');
      const strRutaSonidos = `assets/sounds/${this.ajustesProvider.ajustes.strTemaSonidos}/${Mensaje}.mp3`;

      const audio = new Audio(strRutaSonidos);
      audio.play();
    } else {
      // console.log('no core');
      this.nativeAudio.play(Mensaje);
    }
  }

  speakText(strText: string, blnCancel: boolean): Promise<any> {
    return new Promise<boolean>(async resolve => {

      if (this.platform.is('cordova')) {

        const ttoptions: TTSOptions = {
          locale: 'es-MX',
          identifier: this.strIdentifier,
          text: strText,
          rate: 2.5,
          pitch: 1,
          cancel: blnCancel
        };

        this.tts.speak(ttoptions)
          .then(() => {
            console.log('Hablando', strText);
          })
          .catch((reason: any) => {
            console.log(reason);
          });
      } else {
        console.log('No puedo Hablar', strText);
      }

      resolve(true);

    });
  }
}
